import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=1cb46493&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports